import React from 'react';

import cs from 'app/components/Dashboard/MultiFeatureAnalysisWidget/MultiFeatureAnalysis.module.scss';
import {formatChartType} from 'app/components/Dashboard/utils/chartUtils';
import {formatDate} from 'app/utils/imageryUtils';
import {DataLayerInfo, ImageLayerInfo} from 'app/utils/layers';

import {MultifeatureAnalysisConfig} from '../types';

export const ChartDescription = ({
  widgetConfig,
  layer,
  isExpanded,
  setIsExpanded,
  sharedView = false,
}: {
  widgetConfig: MultifeatureAnalysisConfig;
  layer: DataLayerInfo | ImageLayerInfo;
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  sharedView?: boolean;
}) => {
  return (
    <div>
      <p>
        <span className={cs.widgetLabel}>Description:</span> {widgetConfig.description}
      </p>
      <p>
        <span className={cs.widgetLabel}>Chart: </span>
        {formatChartType(widgetConfig)} of {layer.display}
        {' | '}
        {widgetConfig.featureIds?.length || 'all'} properties
        {' | '}
        {widgetConfig.startDate
          ? formatDate(widgetConfig.startDate, layer.key)
          : 'Earliest available date'}
        {' - '}
        {widgetConfig.endDate ? formatDate(widgetConfig.endDate, layer.key) : 'Present'}
        {!sharedView && (
          <>
            {' | '}
            <a onClick={() => setIsExpanded((expanded) => !expanded)} hidden={sharedView}>
              {isExpanded ? 'See less' : 'See more'}
            </a>
          </>
        )}
      </p>
    </div>
  );
};
